import {
    BEFORE_AUTH,
    CART_ACCOUNT,
    CART_AUTO_UPGRADE,
    CART_CURRENCY,
    CART_DOMAINS,
    CART_EXTRA,
    CART_FLAGS,
    CART_INCLUDE_PRODUCT,
    CART_PERIOD,
    CART_RENEW,
    CART_SAVE_PRODUCTS,
    CART_TARIFF,
    FEATURED,
    FROM_QUERY,
    SYNC_FEATURED_PRODUCTS,
    CART_SELECTED_CUSTOM_BILLS,
} from '../constants/cartContstants';
import { push } from 'redux-first-history';
import {
    productAvailableAccountsSelector,
    productCurrentDomainsSelector,
    productCurrentProductIdSelector,
} from '../selectors/productSelector';
import _ from 'underscore';
import {
    filterPeriodSelector,
    filtersCurrenciesSelector,
    filtersPeriodsByProductSelector,
    newFiltersPeriodByTariffSelector,
    newFiltersTariffsSelector,
} from '../selectors/filtersSelector';
import {
    cartCartSelector,
    cartFeaturedIdsFromQuerySelector,
    cartIncludedProductIdsSelector,
    cartMainProduct,
    cartPeriodIdBeforeAuthSelector,
    cartProductsSelector,
    cartRenewSelector,
    cartTariffIdBeforeAuthSelector,
    cartTariffIdFromQuerySelector,
} from '../selectors/cartSelector';
import { authUserIdSelector } from '../selectors/authSelectors';
import {
    ALLOW_AUTO_INCREASE_FLAG,
    FEATURED_PRODUCTS_PAIR,
    MINIMUM_ALLOWED_PRODUCT_PRICE,
} from '../../constants/constants';
import getCurrentQueryParameters from '../../resolvers/getCurrentQueryParameters';
import { updateQueryParameters } from '../../mutators/updateQueryParameters';
import getProductTitle from '../../resolvers/getProductTitle';
import getBillingUnitsCount from '../../resolvers/getBillingUnitsCount';
import convertToBoolean from '../../lib/string/convertToBoolean';
import isPeriodDifferentByProducts from '../../resolvers/isPeriodDifferentByProducts';
import getDiscountAmountByProduct from '../../resolvers/getDiscountAmountByProduct';

export const getLocation = (state) => state.router.location;

export const setPeriodFromQuery = (data) => ({
    type: CART_PERIOD + FROM_QUERY,
    data,
});
export const setTariffFromQuery = (data) => ({
    type: CART_TARIFF + FROM_QUERY,
    data,
});

export const setExtraFromQuery = (data) => ({
    type: CART_EXTRA + FROM_QUERY,
    data,
});

export const setAppliedFlags = (data) => ({
    type: CART_FLAGS,
    data,
});

export const setCurrencyFromQuery = (data) => ({
    type: CART_CURRENCY + FROM_QUERY,
    data,
});

export const setDomainsFromQuery = (data) => ({
    type: CART_DOMAINS + FROM_QUERY,
    data,
});

export const setAccountFromQuery = (data) => ({
    type: CART_ACCOUNT + FROM_QUERY,
    data,
});

export const setFeaturedFromQuery = (data) => ({
    type: FEATURED + FROM_QUERY,
    data,
});

export const setPeriodBeforeAuth = (data) => ({
    type: CART_PERIOD + BEFORE_AUTH,
    data,
});

export const setTariffBeforeAuth = (data) => ({
    type: CART_TARIFF + BEFORE_AUTH,
    data,
});

export const setPeriod = (data) => (dispatch, getState) => {
    const mainProductId = productCurrentProductIdSelector(getState());
    const filterPeriods = filterPeriodSelector(getState(), {
        product_id: mainProductId,
    });
    const periodBeforeAuth = cartPeriodIdBeforeAuthSelector(getState());

    data = {
        ...data,
    };

    if (!data?.product_id) {
        data.product_id = mainProductId;
    }
    if (
        periodBeforeAuth &&
        filterPeriods &&
        !filterPeriods[periodBeforeAuth]?.isDisabled &&
        !data?.period
    ) {
        data.period = filterPeriods[periodBeforeAuth];
    }
    if ((filterPeriods && filterPeriods[data?.period?.name]?.isDisabled) || !data?.period) {
        data.period = Object.values(filterPeriods)
            .filter((period) => !period.isDisabled)
            .shift();
    }
    if (+mainProductId === +data.product_id && data?.period) {
        const cartIncludedProductIds = cartIncludedProductIdsSelector(getState());

        let params = getCurrentQueryParameters(getState);
        params.period = data?.period?.billing_period;
        params.period_interval = data?.period?.interval;
        updateQueryParameters(dispatch, getState, params);

        data.includedIds = cartIncludedProductIds;

        setTimeout(() => {
            dispatch(
                push({
                    pathname: window.location.pathname, // TODO fix
                    search: '?' + params.toString(),
                })
            );
        }, 0);
    }

    dispatch({
        type: CART_PERIOD,
        data,
    }).then(() => {
        const userId = authUserIdSelector(getState());

        if (!userId) {
            dispatch(setPeriodBeforeAuth(data?.period));
        }
    });
};

export const setCurrency = (currency) => (dispatch, getState) => {
    const currenciesList = filtersCurrenciesSelector(getState());
    // By default - fallback to USD in case of attempt to unset currency.
    if (!currency || !currency?.currency) {
        currency = currenciesList['USD'];
    }

    let params = getCurrentQueryParameters(getState);
     params.currency = currency?.currency;
    updateQueryParameters(dispatch, getState, params);

    dispatch({
        type: CART_CURRENCY,
        data: { currency },
    });
};

export const setDomains = (data) => (dispatch, getState) => {
    let params = getCurrentQueryParameters(getState);

    // The next code is responsible for pre-selecting the default value (domain)
    // if there is no one selected explicitly:
    // - when user visits the page the 1st time (ex ?product_id=5);
    // - when user switches from one product to another.
    if (data.domains === undefined && params.domains === undefined) {
        const availableDomains = productCurrentDomainsSelector(getState());
        data.domains = [availableDomains?.find(Boolean)]?.map((domain) => {
            return { value: domain?.cert_id };
        });
    }
    params.domains = data?.domains?.map((domain => domain?.value));
    updateQueryParameters(dispatch, getState, params);

    dispatch({
        type: CART_DOMAINS,
        data,
    }).then(() => dispatch(syncFeaturedProducts()))
};

export const setAccount = (data) => (dispatch, getState) => {
    const availableAccounts = productAvailableAccountsSelector(getState());
    let params = getCurrentQueryParameters(getState);

    if (!data.account || params.account === undefined) {
        data.account = availableAccounts?.find(Boolean)?.account_id;
    }

    let accountId = data?.account;
    let accountMatched = availableAccounts?.find(item => item?.account_id === accountId);
    if (!accountMatched && availableAccounts.length) {
        accountMatched = availableAccounts?.find(Boolean);
        accountId = accountMatched ? accountMatched?.account_id : null;
        data.account = accountId;
    }

    if (accountMatched) {
        data.merge = {};
        data.productId = data?.productId ?? productCurrentProductIdSelector(getState())
        for (const prop in accountMatched) {
            if (prop !== 'account_id') {
                data.merge[`account_${prop}`] = accountMatched[prop];
            }
        }
    }

    params.account = accountId;
    updateQueryParameters(dispatch, getState, params);

    dispatch({
        type: CART_ACCOUNT,
        data,
    }).then(() => dispatch(syncFeaturedProducts()))
};

export const setNewTariff = (data) => (dispatch, getState) => {
    const mainProductId = productCurrentProductIdSelector(getState());
    const tariffFromQuery = cartTariffIdFromQuerySelector(getState());
    const tariffBeforeAuth = cartTariffIdBeforeAuthSelector(getState());
    const tariffsByPeriod = newFiltersTariffsSelector(getState(), {
        product_id: data.product_id || mainProductId,
    });
    const cart = cartCartSelector(getState());

    if (!data?.product_id) {
        data.product_id = mainProductId;
    }
    if (!data?.tariff) {
        if (
            tariffFromQuery &&
            data.product_id === mainProductId &&
            !tariffsByPeriod[tariffFromQuery]?.isDisabled
        ) {
            data.tariff = tariffsByPeriod[tariffFromQuery];
        }
        // Checks the previous "before auth-change" state and restore it if is available for the main product.
        if (tariffBeforeAuth &&
            data.product_id === mainProductId &&
            tariffsByPeriod[tariffBeforeAuth] &&
            !tariffsByPeriod[tariffBeforeAuth]?.isDisabled) {
            data.tariff = tariffsByPeriod[tariffBeforeAuth];
        }
        if (!data.tariff  && data.product_id === 2) {
            data.tariff = Object.values(tariffsByPeriod)
                .sort((a, b) => a?.checks - b?.checks)
                .find(tariff => tariff?.checks >= FEATURED_PRODUCTS_PAIR[data.product_id]?.defaults?.tariff_services
                    && !tariff?.isDisabled);
        }
        if (!data.tariff) {
            data.tariff = Object.values(tariffsByPeriod)
                ?.filter(
                    (tariff) =>
                        !tariff?.isDisabled &&
                        tariff?.services ===
                            FEATURED_PRODUCTS_PAIR[data.product_id]?.defaults?.tariff_services
                )
                ?.shift();
        }
        if (!data?.tariff) {
            data.tariff = Object.values(tariffsByPeriod)
                ?.filter((tariff) => !tariff?.isDisabled)
                ?.shift();
        }
    }

    if (+mainProductId === +data.product_id && data.tariff) {
        // Has to be updated all featured products (despite being included or not),
        // in order to show relevant data even on inactive option.
        const productIdsToUpdate = [mainProductId].concat(FEATURED_PRODUCTS_PAIR[mainProductId]?.products);
        const servicesCount = getBillingUnitsCount({
            tariff: data.tariff,
            product_id: mainProductId
        }, cart);
        data.tariffs = [];

        if (productIdsToUpdate?.length > 1) {
            productIdsToUpdate?.forEach((product_id) => {
                const featuredTariffs = newFiltersTariffsSelector(getState(), {
                    product_id: product_id,
                });
                const tariff = Object.values(featuredTariffs)
                    ?.sort((a, b) => a?.services - b?.services)
                    ?.filter(
                        (tariff) =>
                            +tariff.services === servicesCount
                            && tariff?.billing_period === data?.tariff?.billing_period
                            && (product_id !== mainProductId || tariff.tariff_id === data?.tariff?.tariff_id)
                    )
                    .shift();
                data.tariffs.push({
                    tariff: tariff,
                    product_id: product_id,
                });
            });
        }

        let params = getCurrentQueryParameters(getState);
        params.tariff_id = data?.tariff?.tariff_id;
        updateQueryParameters(dispatch, getState, params);
    }

    return dispatch({
        type: CART_TARIFF,
        data,
    }).then(() => {
        dispatch(setTariffBeforeAuth(data?.tariff));
        const mainProduct = cartMainProduct(getState());
        document.title = getProductTitle(mainProduct);
    });
};

export const setNewPeriod = (data) => (dispatch, getState) => {
    const mainProductId = productCurrentProductIdSelector(getState());
    const filterPeriods = newFiltersPeriodByTariffSelector(getState(), {
        product_id: mainProductId,
    });
    const periodBeforeAuth = cartPeriodIdBeforeAuthSelector(getState());

    data = {
        ...data,
    };

    if (!data?.product_id) {
        data.product_id = mainProductId;
    }

    if (
        periodBeforeAuth &&
        filterPeriods &&
        !filterPeriods[periodBeforeAuth]?.isDisabled &&
        !data?.period
    ) {
        data.period = filterPeriods[periodBeforeAuth];
    }
    if ((filterPeriods && filterPeriods[data?.period?.name]?.isDisabled) || !data?.period) {
        data.period = Object.values(filterPeriods)
            .filter((period) => !period.isDisabled)
            .shift();
    }
    if (+mainProductId === +data.product_id && data?.period) {
        // Has to be updated all featured products (despite being included or not),
        // in order to show relevant data even on inactive option.
        const productIdsToUpdate = [mainProductId].concat(FEATURED_PRODUCTS_PAIR[mainProductId]?.products);

        let params = getCurrentQueryParameters(getState);
        params.period = data?.period?.billing_period;
        params.period_interval = data?.period?.interval;
        updateQueryParameters(dispatch, getState, params);

        // Actually update period for all cross-selling + main products.
        data.includedIds = productIdsToUpdate;

        dispatch(setPeriodFromQuery({
            period: params.period,
            interval: params.period_interval,
        }));
    }

    dispatch({
        type: CART_PERIOD,
        data,
    }).then(() => {
        const userId = authUserIdSelector(getState());

        if (!userId) {
            dispatch(setPeriodBeforeAuth(data?.period));
        }
        if (data?.period?.billing_period === 'Year' && data?.period?.interval > 1) {

        } else {
            const periods = Object.values(
                filtersPeriodsByProductSelector(getState(), {
                    product_id: data?.product_id,
                })
            )?.filter((period) => period?.interval > 1 && period?.billing_period === 'Year');

            if (periods?.length) {
                dispatch(
                    setRenew({
                        renew: cartRenewSelector(getState()),
                    })
                );
            }
        }
    });
};

export const syncFeaturedProducts = () => (dispatch, getState) => {
    const mainProduct = cartMainProduct(getState());
    const data = {};
    const cartIncludedProductIds = cartIncludedProductIdsSelector(getState());
    const cart = cartCartSelector(getState());
    // For SSL product - consider the number of services to be always equal to 1.
    const servicesCount = mainProduct?.product_id === 5
        ? 1
        : getBillingUnitsCount(mainProduct, cart);

    data.mainProductId = mainProduct?.product_id;
    data.tariffs = [];

    cartIncludedProductIds?.forEach((product_id) => {
        const tariffsByPeriodFeatured = newFiltersTariffsSelector(getState(), {
            product_id: product_id,
        });
        const tariff = Object.values(tariffsByPeriodFeatured)
            ?.sort((a, b) => a.services - b.services)
            ?.filter(
                (tariff) =>
                    ALLOW_AUTO_INCREASE_FLAG
                        ? +tariff?.services >= servicesCount && !tariff.isDisabled
                        : +tariff?.services === servicesCount && !tariff.isDisabled
            )
            .shift();

        if (tariff) {
            data.tariffs.push({
                tariff: tariff,
                product_id: product_id,
            });
        } else if (ALLOW_AUTO_INCREASE_FLAG) {
            const tariff = Object.values(tariffsByPeriodFeatured)
                ?.filter((tariff) => !tariff.isDisabled)
                ?.sort((a, b) => a.cost - b.cost)
                .shift();
            data.tariffs.push({
                tariff: tariff,
                product_id: product_id,
            });
        } else {
            cartIncludedProductIds.splice(cartIncludedProductIds.indexOf(product_id), 1);
            if (product_id !== mainProduct?.product_id) {
                dispatch(includeProduct({ value: false, product_id: product_id, change: true }));
            }
        }
    });

    data.includedIds = cartIncludedProductIds;
    dispatch({
        type: SYNC_FEATURED_PRODUCTS,
        data,
    });
};

export const includeExtra = (data) => (dispatch, getState) => {
    data.includedIds = cartIncludedProductIdsSelector(getState());
    dispatch({
        type: CART_EXTRA,
        data,
    }).then(() => {
        let params = getCurrentQueryParameters(getState);
        params.extra = !!data?.value;
        updateQueryParameters(dispatch, getState, params);
    });
};

export const setRenew = (value) => (dispatch, getState) => {
    if (_.isString(value?.renew)) {
        value = {
            renew: value?.renew === 'true',
        };
    }
    const location = getLocation(getState());
    let params = getCurrentQueryParameters(getState);
    // Initial approach, might be revisited during further testing.
    params.renew = value?.renew ?? location.query?.renew;
    updateQueryParameters(dispatch, getState, params);

    dispatch({
        type: CART_RENEW,
        data: value,
    });
};

export const setAutoUpgrade = (data) => (dispatch, getState) => {
    const location = getLocation(getState());
    let params = getCurrentQueryParameters(getState);
    params.fua = data?.value ?? convertToBoolean(location.query?.fua);
    updateQueryParameters(dispatch, getState, params);

    dispatch({
        type: CART_AUTO_UPGRADE,
        data: { autoUpgrade: params.fua }
    });
};

export const saveProducts = (data) => (dispatch, getState) => {
    const params = getCurrentQueryParameters(getState);
    dispatch({
        type: CART_SAVE_PRODUCTS,
        data,
    }).then(() => {
        dispatch(setNewTariff({})).then(() => {
            const products = cartProductsSelector(getState());
            const mainProductId = productCurrentProductIdSelector(getState());
            const mainProduct = cartMainProduct(getState());
            const featureIdsFromQuery = cartFeaturedIdsFromQuerySelector(getState());
            dispatch(includeExtra({ value: mainProduct?.includeExtra || params.extra, product_id: mainProductId }));

            Object.values(products)?.forEach((product) => {
                const featuredProductId = Object.values(FEATURED_PRODUCTS_PAIR[mainProductId].products)
                    ?.find((product_id) => product?.product_id === product_id);
                if (featuredProductId) {
                    const featuredProduct = products[featuredProductId];
                    dispatch(
                        includeProduct({
                            product_id: product?.product_id,
                            value: featureIdsFromQuery?.includes(product?.product_id) && (product?.product_id === mainProductId
                                || (!isPeriodDifferentByProducts(mainProduct, featuredProduct)
                                    && featuredProduct?.tariff?.cost * featuredProduct?.period?.interval - (getDiscountAmountByProduct(featuredProduct) ?? 0) > MINIMUM_ALLOWED_PRODUCT_PRICE)),
                            change: Array.isArray(featureIdsFromQuery) && featureIdsFromQuery.includes(product?.product_id)
                        })
                    );
                }
            });

            document.title = getProductTitle(mainProduct);
        });
    });
};

export const includeProduct = (data, callback) => (dispatch, getState) => {
    const featureIdsFromQuery = cartFeaturedIdsFromQuerySelector(getState());

    if (featureIdsFromQuery === '*') {
        return;
    } else if (!data?.change && !featureIdsFromQuery?.includes(data?.product_id)) {
        data.value = false;
    }

    dispatch({
        type: CART_INCLUDE_PRODUCT,
        data,
    }).then(() => {
        if (data?.value) {
            dispatch(syncFeaturedProducts());
        }
        const params = getCurrentQueryParameters(getState);
        // No direct updates to params, it's already synced during dispatch action execution.
        updateQueryParameters(dispatch, getState, params);
    }).then(() => {
        if (typeof callback === 'function') {
            callback();
        }
    })
};

export const setCartSelectedBills = (data) => (dispatch) => {
    dispatch({
        type: CART_SELECTED_CUSTOM_BILLS,
        data,
    });
};
